import React from 'react';
import { Animated } from 'react-animated-css';

import LoginCard from './LoginCard';
import './login.css';

const Login = ({ play }) => (
  <Animated animationIn="fadeIn">
    <div className="loginWrapper loginPage" style={{ paddingBottom: play ? '100px' : '20px' }}>
      <div className="fullIcon" />
      <LoginCard />
      <div className="disclaimer">Deca VPP @ 2025 All Rights Reserved.</div>
    </div>
  </Animated>
);

export default Login;
